import React, { useState } from 'react';
import { IpaFrequencyChart } from './chart/IpaFrequencyChart';
import { SynthVowelFormants } from './chart/SynthVowelFormants';
import { ESpeakChart } from './ESpeakChart';
import { LanguageCharts } from './LanguageCharts';
import { LanguageToLanguageCharts } from './LanguageToLanguageCharts';
import { SynthDiphthongFormants } from './chart/SynthDiphthongFormants';
import { SynthNasalFormants } from './chart/SynthNasalFormants';
import { diphthongFormants, rhoticFormants, nonsyllabicFormants, syllabicFormants } from '../phonemes/formants';
import { loadWorldData } from '../loader/loadWorldData';
import { segmentsByLanguage } from '../world/segmentsByLanguage';
import { TrackLanguageFeatures } from '../world/trackLanguageFeatures';
import { getLanguageTrackers } from './LanguageTrackers';
import { IpaNAllophoneChart } from './chart/IpaNAllophoneChart';

export function ChartsArea() {
  const [init, setInit] = useState(false);
  const [segments, setSegments] = useState<Record<string, string>>({});
  const [trackers, setTrackers] = useState<TrackLanguageFeatures | null>(null);
  const [shortNonnasals] = useState<Record<string, number[]>>(getShortNonnasals());
  const [shortNasals] = useState<Record<string, number[]>>(getShortNasals());

  if (!init) {
    setInit(true);
    loadWorldData().then(() => {
      setSegments(segmentsByLanguage);
      setTrackers(getLanguageTrackers());
    });
  }

  return (
    <div style={{ width: 850 }}>
      <h2>IPA charts</h2>
      <IpaNAllophoneChart />
      <hr />
      {trackers === null ? 'loading language data...'
        : <>
          <h2>Phonemes by language</h2>
          <LanguageCharts trackers={trackers} />
          <hr />
          <h2>Compare phonemes between languages</h2>
          <LanguageToLanguageCharts trackers={trackers} />
          <hr />
          <h2>Occurence of phonemes across languages</h2>
          <IpaFrequencyChart segmentsByLanguage={segments} />
          <hr />
        </>
      }
      <h2>eSpeak phonemes</h2>
      <ESpeakChart />
      <hr />
      <SynthVowelFormants />
      <hr />
      <SynthNasalFormants />
      <hr />
      <SynthDiphthongFormants formants={diphthongFormants} />
      <SynthDiphthongFormants formants={rhoticFormants} hideSymbols={['ɞ']} />
      <SynthDiphthongFormants formants={shortNonnasals} />
      <SynthDiphthongFormants formants={shortNasals} />
      <SynthDiphthongFormants formants={syllabicFormants} hideSymbols={['ɝ']} />
    </div>);
}

function getShortNonnasals(): Record<string, number[]> {
  const results: Record<string, number[]> = {};
  const keys = Object.getOwnPropertyNames(nonsyllabicFormants);
  for (const key of keys) {
    if (!key.includes('̃')) results[key] = nonsyllabicFormants[key];
  }
  return results;
}

function getShortNasals(): Record<string, number[]> {
  const results: Record<string, number[]> = {};
  const keys = Object.getOwnPropertyNames(nonsyllabicFormants);
  for (const key of keys) {
    if (key.includes('̃')) results[key] = nonsyllabicFormants[key];
  }
  return results;
}
